module.exports = __webpack_public_path__ + "img/Step11.e0d6ae45.png";